import { localDayISO } from './localDay.js'

// FOS-HOME-WEATHER-STALE-001 (2026-09-28)
//
// The Home header showed "48°" at 8 PM on a 72° evening. It preferred the
// weather frozen onto the morning's wear log (captured 8:27 AM) over the live
// reading, so the first wear of the day pinned the temperature for the rest of
// the day. A wear log's weather is a record of the moment the wear started; it
// is not the weather now.
//
// Rule: "current" temperature comes from the live reading. A wear-log snapshot
// is used only when there is no live reading AND it is recent. Otherwise show
// nothing: no temperature is better than a confidently wrong one.
export const DISPLAY_SNAPSHOT_MAX_AGE_MS = 2 * 60 * 60 * 1000

function validTempC(value) {
  return Number.isFinite(value) && value >= -60 && value <= 60
}

// Newest weather snapshot from today's logs that is no older than maxAgeMs.
export function recentLogWeather(logs = [], now = new Date(), maxAgeMs = DISPLAY_SNAPSHOT_MAX_AGE_MS) {
  const instant = now instanceof Date ? now : new Date(now)
  const nowMs = instant.getTime()
  if (!Number.isFinite(nowMs)) return null
  const today = localDayISO(instant)
  return (logs || [])
    .filter(log => log?.worn_on === today)
    .map(log => log?.context_weather)
    .filter(snapshot => {
      if (!validTempC(snapshot?.temp_c)) return false
      const fetchedMs = Date.parse(snapshot?.fetched_at)
      return Number.isFinite(fetchedMs) && fetchedMs <= nowMs && nowMs - fetchedMs <= maxAgeMs
    })
    .sort((left, right) => Date.parse(right.fetched_at) - Date.parse(left.fetched_at))[0] || null
}

// The weather to treat as "now": live first, then a recent log snapshot, else null.
export function currentDisplayWeather({ liveWeather = null, logs = [], now = new Date() } = {}) {
  if (validTempC(liveWeather?.temp_c)) return liveWeather
  return recentLogWeather(logs, now)
}

export function currentDisplayTempC(args) {
  const weather = currentDisplayWeather(args)
  return weather ? weather.temp_c : null
}

export function formatFahrenheit(tempC) {
  return validTempC(tempC) ? `${Math.round((tempC * 9) / 5 + 32)}°` : null
}
